/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sales_Return_Err_Qty_InvalidInputs */

const vi_sales_return_err_qty_invalid = /** @type {(inputs: Sales_Return_Err_Qty_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số lượng không hợp lệ`)
};

/**

* @param {Sales_Return_Err_Qty_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sales_return_err_qty_invalid = /** @type {((inputs?: Sales_Return_Err_Qty_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Return_Err_Qty_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sales_return_err_qty_invalid(inputs)
});